
import { defineComponent, nextTick, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { initializeComponents } from "@/core/plugins/keenthemes";
import config from "@/config/platform.config";

const { customTheme } = config;

if (customTheme) {
  require(`./platforms/${customTheme}`);
}

export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();
    const isTokenChecked = computed(() => {
      return store.getters["tokens/isTokenChecked"];
    });

    onMounted(async () => {
      /**
       *  Sets a mode from configuration
       */
      store.dispatch(Actions.SET_THEME_MODE_ACTION, "light");
      await store.dispatch("user/checkAndRefresh");

      nextTick(() => {
        initializeComponents();

        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      });
    });
    return {
      isTokenChecked,
    };
  },
});
